// extracted by mini-css-extract-plugin
export default {"container":"YB-z","title":"ZB-z","link":"_B-z"};